module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-icon-open-id-and-connect-btn",
    class: {
      connected: _vm.isAppleEnabled()
    }
  }, [_c('a', {
    staticClass: "social-link",
    attrs: {
      "href": _vm.getAppleLink()
    }
  }, [_c('RoundAppleIcon'), _vm._v(" "), _c('span', {
    staticClass: "connect-btn"
  }, [_vm._v("\n      " + _vm._s(_vm.isAppleEnabled() ?
    _vm.$t('profile.open_id.btn.cancel') :
    _vm.$t('profile.open_id.btn.assign')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5795746","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-page/impl/open-id/open-id-buttons/AppleIconText.vue
// module id = 434
// module chunks = 1